import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Store} from '@ngrx/store';

import {map, take} from 'rxjs/operators';
import {AppState} from '../core.state';
import {AuthSelectors} from '../stores/auth/selectors';
import {MAIN_URL_REDIRECT} from '../@types';
import {LocalStorageService} from '../storages/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class LoginPageGuardService  {
  constructor(private store: Store<AppState>,
              private localStorageService: LocalStorageService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.select(AuthSelectors.selectIsAuthenticated).pipe(
      take(1),
      map((isAuthenticated) => {

        if (isAuthenticated) {
          const mainUrl = this.localStorageService.getMainUrl();
          this.router.navigate([mainUrl], {replaceUrl: true});
          if (mainUrl !== MAIN_URL_REDIRECT) {
          }
        }

        return !isAuthenticated;
      })
    );
  }

}
